import {
  Divider,
  FormControlLabel,
  Radio,
  RadioGroup,
  Slider,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../../../Context/context";
import { baseStyle } from "../../../../theme";
import { BrushItems } from "../../../../TypesAndConstants/Brushes";
import { menuID } from "../../../../TypesAndConstants/const";
import {
  Animation,
  BrushItem,
  ShapeSetting,
} from "../../../../TypesAndConstants/types";
import { THREE_INST } from "../../../SketchUtilities/Three/threeSingleton";
import { MenuContext } from "./TopMenuContext";

export const BrushShortcutMenus = () => {
  const { state: localState } = useContext(MenuContext);
  const { state, dispatch } = useContext(Context);

  const baseStyles = baseStyle({});
  let three = THREE_INST.getInst();

  // useEffect(() => {
  //   three.obj.mountPreview();
  //   three.obj.setPreviewTexture(three.obj.initialBrush);
  //   three.obj.setAlphaTexture(three.obj.initialBrush);
  //   dispatch({ type: "set_active_brush", value: three.obj.initialBrush });
  // }, []);

  const setAnimationMode = (
    event: React.ChangeEvent<{
      name?: string | undefined;
      value: unknown;
    }>
  ) => {
    three.obj.setAnimationMode(parseInt(event.target.value as string, 10));
    dispatch({
      type: "set_brush_animated",
      value: parseInt(event.target.value as string, 10),
    });
  };

  const setBrush = (
    event: React.ChangeEvent<{
      name?: string | undefined;
      value: unknown;
    }>
  ) => {
    three.obj.setPreviewTexture(event.target.value as number);
    three.obj.setTexture(event.target.value as number, state.brushSize);
    dispatch({ type: "set_active_brush", value: event.target.value });
  };

  const setShapeRotationMode = (
    _event: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => {
    const shape: ShapeSetting = {
      shape: state.shapeSettings.shape,
      imageIndex: state.shapeSettings.imageIndex,
      shapeSize: state.shapeSettings.shapeSize,
      shapeRotation: value as any,
    };
    dispatch({ type: "set_shape", value: shape });
  };

  const setShapeSize = (
    event: Event,
    value: number | number[],
    activeThumb: number
  ) => {
    const shape: ShapeSetting = {
      shape: state.shapeSettings.shape,
      imageIndex: state.shapeSettings.imageIndex,
      shapeSize: value as number,
      shapeRotation: state.shapeSettings.shapeRotation,
    };
    dispatch({ type: "set_shape", value: shape });
  };

  const shapeControls = () => {
    const responsiveStyle = baseStyles.sliderContainer;

    return (
      <div
        style={{
          display: state.brushType !== "shape" ? "none" : "inline-block",
          margin: "0 auto",
          width: "80%",
        }}
      >

        <div className={responsiveStyle} style={{ width: "30%" }}>
          {" "}
          <label>Size</label>
          <Slider
            defaultValue={3}
            aria-labelledby="discrete-slider-small-steps"
            onChange={setShapeSize}
            step={1}
            min={1}
            max={2000}
            valueLabelDisplay="auto"
            value={state.shapeSettings.shapeSize}
          />
        </div>
        <div className={responsiveStyle}>
          <RadioGroup
            value={state.shapeSettings.shapeRotation}
            onChange={setShapeRotationMode}
            id={"shapeRadioButton"}
            row
          >
            <FormControlLabel
              value="sliding"
              className={baseStyles.defaultFont}
              control={<Radio />}
              labelPlacement="start"
              label="Allow Sliding"
              style={{ fontFamily: "'amatic', cursive", fontSize: "20px" }}
            />
            <Divider />
            <FormControlLabel
              value="rotation"
              className={baseStyles.defaultFont}
              control={<Radio />}
              labelPlacement="start"
              label="Allow Rotation"
              style={{ fontFamily: "'amatic', cursive" }}
            />
            <Divider />
            <FormControlLabel
              value="drag"
              className={baseStyles.defaultFont}
              control={<Radio />}
              labelPlacement="start"
              label="Free Drag"
              style={{ fontFamily: "'amatic', cursive" }}
            />
          </RadioGroup>
        </div>
      </div>
    );
  };

  const brushControls = () => {
    return (
      <div
        style={{
          display: state.brushType === "shape" ? "none" : "inline-block",
        }}
      >
        <div className={"topMenuContent "}>
          <div id="topHoverButton" className={"shortcutItemContainer "+ baseStyles.shortcutMenuItem}>
            <div className={"shortcutItemLabel"}>Brush:</div>
            <div className={"topButtonSelectContainer"}>
              <select
                className={"topButtonSelect"}
                value={state.activeBrush}
                onChange={setBrush}
                style={{ fontSize: "1.2rem" }}
              >
                {BrushItems.map((brush: BrushItem) => {
                  return (
                    <option key={brush.name} value={brush.brushType}>
                      {brush.name}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div id="topHoverButton" className={"shortcutItemContainer "+ baseStyles.shortcutMenuItem}>
            <div className={"shortcutItemLabel"}>Animation:</div>
            <div className={"topButtonSelectContainer"}>
              <select className={"topButtonSelect"} onChange={setAnimationMode} style={{ fontSize: "1.2rem" }}>
                <option value={Animation.None}>None</option>
                <option value={Animation.Wavey_Size}>Wavey Size</option>
                <option value={Animation.Wavey_Rotate}>Wavey Rotate</option>
                <option value={Animation.Rotate}>Rotate</option>
                <option value={Animation.Scatter}>Scatter</option>
              </select>
            </div>
          </div>
          <div id="topHoverButton" className={"shortcutItemContainer "+ baseStyles.shortcutMenuItem}>
            <div className={"shortcutItemLabel"}>Size:</div>
            <div style={{ fontSize: "20px", margin: "0 5px" }}>
              {state.brushSize + "px"}
            </div>
            <div
              className={"topButtonSelectContainer"}
              style={{ width: "55%" }}
            >
              <Slider
                onChange={(e, v) => {
                  dispatch({
                    type: "set_brush_size",
                    value: v as any,
                  });
                }}
                min={1}
                max={400}
                step={0.1}
                value={state.brushSize || 25}
              />
            </div>
          </div>
          <div id="topHoverButton" className={"shortcutItemContainer "+ baseStyles.shortcutMenuItem}>
            <div className={"shortcutItemLabel"}>Speed:</div>
            <div style={{ fontSize: "20px", margin: "0 5px" }}>
              {state.brushPlaybackRate}
            </div>
            <div
              className={"topButtonSelectContainer"}
              id={"topSlider"}
              style={{ width: "55%" }}
            >
              <Slider
                onChange={(e, v) => {
                  dispatch({
                      type: "set_brush_playback_speed",
                      value: v as number,
                    })
                  three.obj.setPlaybackRate(v as number);
                }}
                min={0.1}
                max={4}
                step={0.1}
                value={state.brushPlaybackRate}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div >
        <div
          id={menuID.TopBrushMenu}
          //className={state.brushType !== "shape" ? "" : baseStyles.background}
          style={
            state.brushType !== "shape"
              ? {
                  fontFamily: "'amatic', cursive",
                  height: "fit-content",
                  width: "85%",
                  top: 0,
                  left: "5%",
                  zIndex: 2000,
                }
              : {
                  fontFamily: "'amatic', cursive",
                  height: "fit-content",
                  width: "60%",
                  top: 0,
                  left: "20%",
                  borderTop: "0px",
                  borderBottomLeftRadius: "5px",
                  borderBottomRightRadius: " 5px",
                  borderTopLeftRadius: "0px",
                  borderTopRightRadius: "0px",
                  zIndex: 2000,
                }
          }
        >
        {brushControls()}
        </div>
        {shapeControls()}
        <div
          style={{
            fontFamily: "'amatic', cursive",
            position: "absolute",
            bottom: "2%",
            width: "100%",
            zIndex: 10000,
            marginBottom: "4px",
            marginLeft: "33%",
          }}
        ></div>
      </div>
    </>
  );
};
